<template>
    <i class="iconfont icon-locate" :style="css" @click="click"></i>
</template>
<script>
import Base from './base';
export default {
    mixins: [Base],
    methods: {
        handler([map, maps, module]) {
            module.setCenter(module.config.center, module.config.zoom);
        }
    }
};
</script>
